export var ConnectionType;
(function (ConnectionType) {
    ConnectionType["CONNECT"] = "add-friend";
    ConnectionType["BLOCK"] = "block";
})(ConnectionType || (ConnectionType = {}));
//# sourceMappingURL=IUserProfile.js.map